<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
    :empty='empty'
    :pageSize="pageParams.pageSize"
    :pageIndex="pageParams.pageIndex"
    :listTotal='total'
    :pageType="pageType"
    @currentPage="currentPage"
    @inputText="inputText"
  />
</template>
<script>
import complexSelect from "@/components/common/complexSelect";
export default {
  components: {
    complexSelect,
  },
  props: {
    pageType: {
      type: Boolean,
      default: false,
    },
    listTotal: {
      type: Number,
      default: undefined,
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    pageIndex:{
      type: Number,
      default: undefined,
    },
    init: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: () => [],
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    keyword: {
      type: String,
      default: "GoodsName",
    },
    value: {},
    // Head: {
    //   type: Array,
    //   default:  [
    //     { Value: "GoodsCode", Name: "商品条码", Width: "180" },
    //     { Value: "GoodsName", Name: "商品名称", Width: "150" },
    //   ],
    // },
  },
  data() {
    return {
      // api: require("@/api/ba/account").default,
      api:"",
      Head: [
        { Value: "GoodsCode", Name: "商品条码", Width: "100" },
        { Value: "GoodsName", Name: "商品名称", Width: "290" },
        { Value: "Model", Name: "规格型号", Width: "130" },
        { Value: "MainUnitName", Name: "主单位", Width: "80" },
      ],
      Data: [],
      total:0,
      value1: "",
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: this.pageIndex,
      },
    };
  },
  watch: {
    pageIndex() {
      
      this.pageParams.pageIndex = this.pageIndex;
    },
    value() {
      // 
      this.value1 = this.value;
    },
    source() {
      
      this.Data = this.source;
    },
    listTotal() {
      this.total = this.listTotal;
    },
  },
  mounted() {
    this.value1 = this.value;
    if (this.init) this.initData();
    else this.Data = this.source; this.total = this.listTotal;
  },
  methods: {
    inputText(text){
      this.$emit("inputText",text);
    },
    currentPage(val){
      this.$emit("currentPage", val);
    },
    initData() {
      
      this.api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Data = res.Data;
      });
    },
    onSelect(data) {
      
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>